import {
    setPianoRollCursor
} from 'actions/index.js';
 
export const duplicateSteps = (track, selectedSteps, resolution) => {
    let stepNumber = 0;
    let pattern = track.getEasyPattern();
    let allSteps = !selectedSteps || selectedSteps.length == 0;
    let state = track.sequencerEngine.state;
    if (allSteps) {
        selectedSteps = pattern.getAllSteps();
        stepNumber = track.pattern.length(resolution);
    }
    // find last step's step number and find next bar after duration
    let stepNumbers = pattern.getStepNumbers(selectedSteps, resolution);
    let maxStepNumber=-1;
    let maxStep =undefined;
    for (let [stepData, stepNumber] of stepNumbers) {
        if (stepNumber > maxStepNumber) {
            maxStepNumber = stepNumber;
            maxStep = stepData;
        }
    }
    
    let maxedStep = maxStepNumber + ((resolution.resolution / 4) - (maxStepNumber % (resolution.resolution / 4)));
    if (!allSteps && state.keyboard.cursor !== undefined) {
        stepNumber = state.keyboard.cursor - (state.keyboard.cursor % (resolution.resolution/4));
    } else if (!allSteps) {
        // now find the duration of this max step
        // now lets find the next bar after this
        stepNumber = maxedStep;
    }
    if (allSteps || stepNumber >= track.pattern.length(resolution)) {
        track.doubleTrackLength();
    }
    // get first step with ON and add that step number
    let firstStep = allSteps ?
        pattern.getFirstOnStep(resolution)  :
        pattern.getFirstStepNumber(selectedSteps, resolution);
    if (allSteps) {
        stepNumber += (firstStep);
    } else {
        stepNumber += (firstStep % (resolution.resolution / 4));
    }
    
    let pastedSteps = track.getEasyPattern().pasteSteps(
        selectedSteps,
        {stepNumber},
        pattern,
        resolution
    );
    track.updateSteps();
    let barLength = maxedStep - (firstStep - (firstStep % (resolution.resolution / 4)));
    track.sequencerEngine.dispatch(setPianoRollCursor(stepNumber + barLength));
};

